var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissedCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_13672"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_13672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5 5.5 5.5 5.5 7-7-1-1-6 6-4.5-4.5h3.5v-1.5h-6v6h1.5zm17.21 11.17c-3.05-2.89-7.17-4.67-11.71-4.67s-8.66 1.78-11.71 4.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z",
    fill: "#df1414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedCall);
export default __webpack_public_path__ + "static/media/missed-call.e88def5a8083222c6e8c205585f2bef6.svg";
export { ForwardRef as ReactComponent };